import enLoacle from 'element-ui/lib/locale/lang/en'
const en = {
  top: {
    Home: 'Home',
    About: 'About',
    Company_Profile: 'Company Profile',
    Corporate_philosophy: 'Corporate philosophy',
    Corporate_Honors: 'Corporate Honors',
    Company_Scenarios: 'Company Scenarios',
    Products: 'Products',
    News: 'News',
    Service: 'Service',
    Contact: 'Contact',
    Cnlang: 'Cn',
    Enlang: 'En'
  },
  home: {
    WhyChooseUs: 'Why Choose Us?',
    LatestNews: 'Latest News',
    PurchaseNow: 'Purchase Now',
    SomeofOurClients: 'Some of Our Clients',
    ReadMore: 'Read More'
  },
  footer: {
    Phone: 'Phone',
    EMail: 'E-Mail',
    Web: 'web',
    Address: 'Address'
  },
  common: {
    CompanyName: 'WENLING GLANG INTELLIGENT TECHNOLOGY CO., LTD',
    Glang: 'Glang',
    CompanyAddress: 'Building 1, Zone A, Incubation Park, Eastern New Area, Wenling City, Zhejiang Province',
    CurrentLocation: 'Your current location',
    ReadMore: 'Read More',
    LearnMore: 'Learn More',
    ProductsDetail: 'Products Detail',
    NewsDetail: 'News Detail',
    ServiceDetail: 'Service Detail'
  },
  contact: {
    LeaveAMessage: 'LEAVE A MESSAGE',
    Name: 'Name (required)',
    Phone: 'Phone (required)',
    EMail: 'E-mail (required)',
    MessageContent: 'Message content',
    Send: 'Send'
  },
  products: {
    AllProducts: 'All products',
    Next: 'Next',
    Prev: 'Prev',
    ProductOverview: 'Product Overview',
    UseCondition: 'Use Condition',
    ModelDescription: 'Model Description',
    TechnicalParameter: 'Technical Parameter',
    PerformanceCurve: 'Performance Curve',
    ProductDetails: 'Product Details',
    ModelName: 'Basic Parameters',
    RelatedProducts: 'Related Products',
    Message: 'Message'
  },
  ...enLoacle
}

export default en
